var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"situacao-familiar","rota-base":"/admin/situacao-familiar","titulo":"SITUAÇÕES FAMILIARES","titulo-singular":"Situação Familiar","colunas-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }